var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2082 16.0839C12.5533 16.0838 12.8333 16.3636 12.8333 16.7088C12.8333 17.0539 12.5537 17.3338 12.2085 17.3339L1.37518 17.3371C1.03 17.3372 0.75 17.0574 0.75 16.7123C0.75 16.3671 1.02964 16.0872 1.37482 16.0871L12.2082 16.0839ZM6.70683 0.677095L6.79167 0.671387C7.10808 0.671387 7.36958 0.906512 7.411 1.21158L7.41667 1.29639L7.41583 12.7006L10.5173 9.60025C10.7393 9.37842 11.0865 9.35825 11.3312 9.53983L11.4013 9.60034C11.6231 9.82225 11.6433 10.1695 11.4617 10.4142L11.4012 10.4843L7.23642 14.6481C7.01467 14.8698 6.66767 14.8901 6.423 14.7088L6.35292 14.6483L2.18336 10.4845C1.93912 10.2406 1.93884 9.84484 2.18276 9.60058C2.40449 9.37858 2.7517 9.35817 2.9965 9.53959L3.06664 9.6L6.16583 12.6948L6.16667 1.29639C6.16667 0.97997 6.40183 0.718478 6.70683 0.677095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.46d9e8088395554ff648846f8d7fa4ac.svg";
export { ForwardRef as ReactComponent };